import { MDXProvider } from '@mdx-js/react'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { BrowserRouter } from 'react-router'

import { App } from './App'
import { GoogleTagManager } from './components/GoogleTagManager'
import { useMDXComponents } from './mdx-components'
import './pages/globals.css'

const Root = () => {
  const components = useMDXComponents({})

  return (
    <HelmetProvider>
      <BrowserRouter>
        <MDXProvider components={components}>
          <App />
        </MDXProvider>
      </BrowserRouter>
    </HelmetProvider>
  )
}

const rootElement = document.getElementById('root') as HTMLElement
const tree = (
  <React.StrictMode>
    <GoogleTagManager />
    <Root />
  </React.StrictMode>
)

// Every route is prerendered (scripts/prerender.mjs), so the root element already
// has markup on first paint - hydrate it instead of discarding and re-rendering.
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, tree)
} else {
  ReactDOM.createRoot(rootElement).render(tree)
}
